import React, { useEffect } from 'react';
import { C } from './UI';

interface Props {
    photoUrl: string;
    onClose: () => void;
    estimatedUnits?: number;
    address?: string;
}

export function PhotoModal({ photoUrl, onClose, estimatedUnits, address }: Props) {
    // Close on Escape key
    useEffect(() => {
        const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [onClose]);

    // Prevent body scroll while open
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = ''; };
    }, []);

    return (
        // Backdrop
        <div
            onClick={onClose}
            style={{
                position: 'fixed', inset: 0, zIndex: 1000,
                background: 'rgba(0,0,0,0.75)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: 24,
                backdropFilter: 'blur(4px)',
            }}
        >
            {/* Modal — stop click propagating to backdrop */}
            <div
                onClick={e => e.stopPropagation()}
                style={{
                    background: '#fff',
                    borderRadius: 14,
                    overflow: 'hidden',
                    maxWidth: 520,
                    width: '100%',
                    boxShadow: '0 24px 80px rgba(0,0,0,0.35)',
                }}
            >
                {/* Header */}
                <div style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: '12px 16px',
                    borderBottom: `1px solid ${C.border}`,
                }}>
                    <div>
                        <div style={{ fontWeight: 600, fontSize: 14, color: C.text }}>
                            📷 Customer photo
                        </div>
                        {address && (
                            <div style={{ fontSize: 12, color: C.textSub, marginTop: 2 }}>
                                {address}
                            </div>
                        )}
                    </div>
                    <button
                        onClick={onClose}
                        style={{
                            background: C.bg, border: 'none', borderRadius: '50%',
                            width: 32, height: 32, cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 16, color: C.textSub,
                        }}
                    >
                        ✕
                    </button>
                </div>

                {/* Photo */}
                <div style={{ position: 'relative' }}>
                    <img
                        src={photoUrl}
                        alt="Pickup pile"
                        style={{
                            width: '100%',
                            maxHeight: 420,
                            objectFit: 'contain',
                            display: 'block',
                            background: '#f0f0f0',
                        }}
                    />
                </div>

                {/* Footer */}
                {estimatedUnits && (
                    <div style={{
                        padding: '12px 16px',
                        background: C.greenBg,
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    }}>
                        <div style={{ fontSize: 13, color: C.green }}>
                            🤖 AI estimated <strong>{estimatedUnits} boxes</strong>
                        </div>
                        <div style={{ fontSize: 11, color: C.textSub }}>
                            Tap outside to close
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
